import React from "react";
import { Link } from "react-router-dom";
import { fmtDate, labelize, money } from "@/lib/constants";

function InfoTile({ k, v }) {
  return (
    <div>
      <div className="label-mono">{k}</div>
      <div className="mt-0.5">{v || "—"}</div>
    </div>
  );
}

/** Left card on the BadLeadDetail page: details + notes + evidence links. */
export default function BadLeadDetailsCard({ report, lead }) {
  return (
    <div className="brut-card p-5 lg:col-span-2">
      <div className="font-chivo font-bold uppercase tracking-tight mb-3">Details</div>
      <dl className="text-sm font-mono grid grid-cols-2 gap-3">
        <InfoTile k="Lead" v={
          <Link to={`/leads/${report.lead_id}`} className="hover:underline">
            {lead?.first_name} {lead?.last_name} · {report.lead_id.slice(0, 8)}
          </Link>
        } />
        <InfoTile k="Reason" v={labelize(report.reason)} />
        <InfoTile k="Requested resolution" v={labelize(report.requested_resolution)} />
        <InfoTile k="Return window" v={report.return_window_status} />
        <InfoTile k="Reporter" v={`${report.reporting_user_name} (${report.reporting_org_type})`} />
        <InfoTile k="Discovered" v={fmtDate(report.date_discovered)} />
        <InfoTile k="Reported" v={fmtDate(report.created_at)} />
        <InfoTile k="Decision" v={labelize(report.decision) || "—"} />
        {report.credit_amount != null && <InfoTile k="Credit" v={money(report.credit_amount)} />}
        {report.replacement_lead_id && (
          <InfoTile k="Replacement lead"
            v={<Link to={`/leads/${report.replacement_lead_id}`} className="hover:underline">
              {report.replacement_lead_id.slice(0, 8)}
            </Link>}
          />
        )}
      </dl>

      <div className="mt-4">
        <div className="label-mono">Notes</div>
        <div className="border border-black p-3 text-sm mt-1 whitespace-pre-wrap">{report.notes}</div>
      </div>

      {report.evidence_file_ids?.length > 0 && (
        <div className="mt-3">
          <div className="label-mono">Evidence</div>
          <ul className="text-xs font-mono mt-1">
            {report.evidence_file_ids.map((fid) => (
              <li key={fid}>
                <a
                  href={`${process.env.REACT_APP_BACKEND_URL}/api/files/${fid}`}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:underline"
                >
                  {fid}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
